import { useLocation, useNavigate } from 'react-router-dom';
import { hapticFeedback } from '@telegram-apps/sdk';
import { TABS, TabItem } from '../../types';
import './TabBar.css';

interface TabBarProps {
  isAdmin?: boolean;
}

export function TabBar({ isAdmin = false }: TabBarProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const visibleTabs = TABS.filter((tab) => !tab.adminOnly || isAdmin);

  const handleTabClick = (tab: TabItem) => {
    // Haptic feedback
    if (hapticFeedback.impactOccurred.isAvailable()) {
      hapticFeedback.impactOccurred('light');
    }

    navigate(tab.path);
  };

  const isActive = (tab: TabItem): boolean => {
    if (tab.path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(tab.path);
  };

  return (
    <nav className="tab-bar">
      {visibleTabs.map((tab) => (
        <button
          key={tab.id}
          className={`tab-bar-item ${isActive(tab) ? 'tab-bar-item--active' : ''}`}
          onClick={() => handleTabClick(tab)}
          type="button"
        >
          <span className="tab-bar-icon">{tab.icon}</span>
          <span className="tab-bar-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}
